import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const RhsWrapper = styled(Box)(`
  width:650px;
  display:flex;
  justify-content: end;
  align-items: center;
  & > button {
    margin-left:12px;
  }

  & .BtnAskIA .dynamicTourText span {
    margin-top : 15px;
  }
`)

export const DashboardNavbarRoot = styled(Box)(`
  display: flex;
`)

export const ContentWrapper = styled(Box)(
  (props) => `
  background-color: #232323;
  color:#fff;
  padding: 0 20px;
  height: 60px;
  display: ${props.isroot ? 'none' : 'flex'};
  flex-direction: column;
  justify-content: center;
  text-align: center;
  text-transform: capitalize;
`
)

export const HiddenPptLogo = styled(Box)(`
  position:absolute;
  width:1px;
  height:1px;
  overflow:hidden;
`)

export const DesktopMenu = styled(Box)(`
  display:flex;
  @media (max-width: 980px) {
    display:none;
  }
`)

export const MobileMenu = styled(Box)(`
  display:none;
  @media (max-width: 980px) {
    display:block;
  }
`)

export const LoaderOverlay = styled(Box)(`
  position: fixed;
  z-index: 1300;
  width:100vw;
  height:100vh;
  display:block;
  background: rgba(0, 0, 0, 0.5);
  top:0;
  left:0;
`)

export const IsDummyAccount = styled(Box)(`
  position: fixed;
  z-index: 1300;
  width:60%;
  display:block;
  background: red;
  top:0;
  left:20%;
  padding:5px;
  border-bottom-left-radius: 80px 80px;
  border-bottom-right-radius: 80px 80px;
  text-align:center;
  &:before {
    content: 'This is Test Account!!';
    color:#fff;
    font-weight:bold;
    text-transform:uppercase;
    font-size:25px;
  }
`)
